import { createIcon } from "@chakra-ui/react";

const SortIcon = createIcon({
  displayName: "SortIcon",
  viewBox: "0 0 24 24",
  path: <path d="M3 18v-2h6v2H3Zm0-5v-2h12v2H3Zm0-5V6h18v2H3Z" fill="currentColor" />,
});

export default SortIcon;
